/**
 * Legal abbreviations for text expansion.
 * When a user types an abbreviation followed by a space, it expands to the full text.
 */
export const ABBREVIATIONS: Record<string, string> = {
  apar: "Appearance at and participation in",
  cf: "correspondence from",
  cfp: "counsel for plaintiffs",
  cmc: "Case Management Conference",
  cmo: "case management order",
  cmp: "case management plan",
  cms: "Case Management Statement",
  comms: "communications with",
  corr: "correspondence",
  cr: "claims representative",
  cra: "certificate regarding compulsory arbitration",
  ct: "correspondence to",
  cv: "curriculum vitae",
  cw: "correspondence with",
  cwc: "correspondence with client",
  cwoc: "correspondence with opposing counsel",
  dec: "Draft email correspondence to",
  decl: "declaration",
  depo: "deposition",
  dm: "Draft Motion",
  dmil: "Draft Motion in Limine",
  docs: "documents",
  drr: "Draft and revise",
  edw: "email discussion with",
  eoc: "exclusive of travel time",
  eott: "(exclusive of travel time)",
  era: "Extensive review and analysis of",
  ewd: "Expert Witness Designation",
  excont: "ex parte application to continue trial",
  fac: "First Amended Complaint",
  fh: "further handling",
  fpo: "for purposes of",
  frog: "form interrogatories",
  fsc: "Final Status Conference",
  gfs: "good faith settlement",
  idc: "informal discovery conference",
  ids: "initial disclosure statement",
  ime: "independent medical examination",
  ioc: "inclusive of travel time",
  info: "information",
  ipo: "in preparation of",
  iso: "in support of",
  itc: "length telephone conference with",
  mil: "Motion in Limine",
  msa: "Motion for Summary Adjudication",
  msc: "mandatory settlement conference",
  msj: "Motion for Summary Judgment",
  mtc: "Motion to Compel",
  nod: "Notice of Deposition",
  nui: "non-uniform interrogatories",
  oc: "opposing counsel",
  ost: "Order Shortening Time",
  pc: "plaintiff's counsel",
  pcs: "plaintiffs' counsel",
  plf: "plaintiff",
  plaitniff: "plaintiff",
  pmk: "person most knowledgeable",
  ra: "review and analysis of",
  raec: "Review and analysis of electronic correspondence",
  re: "regarding",
  rfa: "Request for Admissions",
  rfd: "request for dismissal",
  rfp: "Request for Production of Documents",
  sar: "Settlement & Release Agreement",
  sdt: "subpoena duces tecum",
  sof: "Statement of Facts",
  sow: "scope of work",
  sprog: "special interrogatories",
  tbi: "traumatic brain injury",
  tc: "telephone conference with",
  teh: "the",
  ui: "uniform interrogatories",
  vc: "video conference",
  wat: "with attention to",
};
